<template>
    <div class="fill-height of-y">
      
      <v-card-title class="mx-auto" style="max-width: 500px" >
        Shifts
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="showAddShift = !showAddShift">Add Shift</v-btn>
      </v-card-title>
      
      <v-card-text
          v-if="showAddShift"
          @done="showAddShift = false"
          class="mx-auto"
          style="max-width: 500px"
      >
        <v-card title="Add Shift">
          <setup-shift
              class="mx-auto"
              style="max-width: 500px"
              :src-shift="null"
              @done="showAddShift = false"
          ></setup-shift>
        </v-card>
      </v-card-text>
      
      <v-card-text
          class="mx-auto"
          style="max-width: 500px"
      >
        <v-card
            class="mb-3"
            v-for="shift in visibleShifts" :key="shift.id"
        >
          <setup-shift
              :src-shift="shift"
          ></setup-shift>
        </v-card>
        
      </v-card-text>
      
    </div>
</template>

<script>
import {mapGetters} from 'vuex'
import MultiSelectList from "../../General/Multi Select List/MultiSelectList";
import ModifyUser from "./SetupShift.vue";
import {waitForEvent} from "../../../core/socket";
import Divider from "../../General/Divider";
import ManageBarcodes from "../Manage Barcodes/ManageBarcodes";
import SetupShift from "@/components/Setup/Shifts/SetupShift.vue";

export default {
    components: {SetupShift, ManageBarcodes, Divider, ModifyUser, MultiSelectList},
    props: {},
    data() {
        return {
          showAddShift: false
        }
    },
    watch: {

    },
    methods: {
    
    },
    computed: {
        ...mapGetters(['users']),
        visibleShifts() {
          return this.$store.state.shifts.filter(shift => !shift.removed)
        }
    },
}
</script>

<style scoped>

</style>